import { TEquipmentLocationDto } from '@/pages/Equipment/equipment.types'
import geoSuggestUtils from '@/services/geoSuggest/geoSuggest.utils'
import AddressInput, { TAddressInputData } from '@/shared/Inputs/AddressInput'
import { useMemo, useState } from 'react'

interface IProps {
  location: Omit<TEquipmentLocationDto, 'locationDescription'>
  onChange: (location: Omit<TEquipmentLocationDto, 'locationDescription'>) => void
}

const EquipmentLocationInput = (props: IProps) => {
  const [errorMsg, setErrorMsg] = useState('')

  const addressLine: string = useMemo(() => {
    if (!props.location) return ''
    return [props.location.country, props.location.region, props.location.city, props.location.address]
      .filter(Boolean)
      .join(', ')
  }, [props.location])

  const handleChange = (value: TAddressInputData) => {
    const addressFields = geoSuggestUtils.getAddressFieldsFromAddressInputData(value.аddressСomponents)
    props.onChange({
      ...props.location,
      ...addressFields,
      postalCode: value.postalCode,
      latitude: value.lat,
      longitude: value.lng,
    })
  }

  const onValidate = (value: TAddressInputData) => {
    if (value.kind !== 'house' && value.kind !== 'entrance') {
      setErrorMsg('Пожалуйста, выберите адрес, указывающий на дом или подъезд.')
    } else {
      setErrorMsg('')
    }
  }

  return (
    <AddressInput
      addressLine={addressLine}
      onChange={(v) => {
        handleChange(v), onValidate(v)
      }}
      error={Boolean(errorMsg)}
      inscription={errorMsg}
    />
  )
}

export default EquipmentLocationInput
